import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserPreference } from 'app/modules/models/userPreference.type';
import { StoreService } from 'app/ngrx/store.service';
import { environment } from 'environments/environment';
import { map, Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserPreferencesService {
    protected apiRoute = environment.RESOURCE_API;
    constructor(private _httpClient: HttpClient, private _storeService: StoreService) { }

    getMine(): Observable<UserPreference[]> {
        const route = this.apiRoute + environment.apiCatalog.userPreferences.mine;
        return this._httpClient.get(route, this.prepareHeader()).pipe(map(res => res as UserPreference[]))
    }

    // Charge toutes les préférences de l'utilisateur connecté dans le store ({ code: valeur }).
    loadMine(): Observable<{ [code: string]: string }> {
        return this.getMine().pipe(
            map(preferences => Object.fromEntries(preferences.map(p => [p.code, p.value]))),
            tap(userPreferences => this._storeService.setUserPreferences(userPreferences))
        );
    }

    setMine(code: string, value: string): Observable<UserPreference> {
        const route = this.apiRoute + environment.apiCatalog.userPreferences.mine + '/' + code;
        return this._httpClient.put(route, { value }, this.prepareHeader()).pipe(map(res => res as UserPreference))
    }

    private prepareHeader(): Object {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        return { headers: headers };
    }
}
